import React from 'react';
import Countdown from '../../../../components/Countdown/Countdown';
import ImageSlider from '../../../../components/ImageSlider/ImageSlider';
import { useStateContext } from '../../../../context/ContextProvider';
import LanguageNavigate from '../../../../components/Language/LanguageNavigate';
import Footer from '../../../../components/Footer/Footer';
import NoiseBackground from '../../../../components/Background/NoiseBackground';
import LeadFormRetail from '../../../../components/LeadForm/LeadFormRetail';
import Height15 from '../../../../components/Gap/Height';
import LeadFormRetailCRM from '../../../../components/LeadForm/LeadFormRetailCRM';


function AziziRivieraRetailNina({
    language
}) {
    const {
        langs,
        langCode,
        userInfo,
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const images = [
        "/assets/images/projects/azizi-riviera-retail/1.webp",
        "/assets/images/projects/azizi-riviera-retail/2.webp",
        "/assets/images/projects/azizi-riviera-retail/3.webp",
        "/assets/images/projects/azizi-riviera-retail/4.webp",
        "/assets/images/projects/azizi-riviera-retail/5.webp"
    ];

    return (
        <>
            <div>
                <NoiseBackground />
                {/* LANGUAGE */}
                <LanguageNavigate
                    redirect={language === "ar"
                        ? "/offer/azizi/riviera/retail"
                        : "/offer/azizi/riviera/retail/ar"}
                />
                {/* LIMITED TIME OFFER */}
                <div className="padding-container my-5 py-5">
                    <Countdown />
                </div>
                
                <Height15 />

                {/* HEADING */}
                <div className="padding-container text-center my-5 py-5">
                    {language === "ar"
                        ? (
                            <h1 className="text-center px-2 my-1 text-xl">
                                امتلك وحدتك التجارية في دبي ابتداءً من
                                <span className="text-2xl bounce-text secondary-text" id="price">
                                    {
                                        (userInfo?.countryCode === "AE" || userInfo?.countryCode === "ae")
                                            ? "299,000 درهم"
                                            : "$81,000"
                                    }
                                </span>
                            </h1>
                        ) : (
                            <h1 className="text-center px-2 my-1 text-xl">
                                Own your retail space in Dubai starting at just
                                <span className="text-2xl bounce-text secondary-text" id="price">
                                    {
                                        (userInfo?.countryCode === "AE" || userInfo?.countryCode === "ae")
                                            ? "AED 299,000"
                                            : "$81,000"
                                    }
                                </span>
                            </h1>
                        )
                    }
                </div>
                {/* IMAGES */}
                <ImageSlider images={images} />
                {/* FORM */}
                <div className="padding-container py-5 my-5">
                    {/* LEAD FORM */}
                    <LeadFormRetailCRM
                        developer="Azizi"
                        project="Riviera"
                        leadType="Commercial"
                        enquiryType="Retail"
                        language={currentLang?.name}
                    />
                </div>

                <Height15 />

            </div>
            <Footer />
        </>
    );
}

export default AziziRivieraRetailNina;
